import React from 'react';
import { Route, Switch, Redirect, withRouter } from 'react-router-dom';
import { ROUTE_HOME, ROUTE_ERROR, ROUTE_HOME_INDEX, ROUTE, ROUTE_ASSISTENZA, ROUTE_RICEVUTE_DETTAGLIO_2  , ROUTE_ELENCHI ,ROUTE_RICEVUTE_DETTAGLIO, ROUTE_FROM_UNIMODWEB,ROUTE_RESTITUZIONE_DUPLO,ROUTE_DUPLI_RESTITUITI, ROUTE_FROM_PEGNI, ROUTE_TRASMISSIONE, ROUTE_RICEVUTE, ROUTE_PROFILAZIONE, ROUTE_RICEVUTE_DETTAGLIO_AVVISO, ROUTE_PAGAMENTO_INTEGRATIVO, ROUTE_FERMO, ROUTE_FROM_PEGNI_CERTIFICATI, ROUTE_COMPILAZIONE_MUI,  ROUTE_FROM_UNIMODWEB_BB, ROUTE_ESITI_CONTESTUALI , ROUTE_FROM_CANCELLAZIONI_IPOTECA, ROUTE_COMPILAZIONE_CI, ROUTE_HOME_CI  } from '../../assets/frontendRouting.js';
import Errore from '../errore.jsx'
import NotFound from '../notfound.jsx';
import Help from '../help.jsx';
import {Trasmissione as TrasmissionePegno} from '../pegno/trasmissione.jsx';
import {Trasmissione as TrasmissioneModelloUnico} from '../pegno/trasmissione.jsx';
import {Trasmissione as TrasmissionePegnoCertificati} from '../pegno/trasmissione.jsx';
import {Trasmissione as TrasmissioneComCanc} from '../pegno/trasmissione.jsx';
import {Ricevute as RicevutePegno} from '../pegno/ricevute.jsx';
import {Ricevute as RicevuteModelloUnico} from '../pegno/ricevute.jsx';
import {Ricevute as Elenchi} from '../pegno/ricevute.jsx';
import {Ricevute as RicevuteComunicazioniCancellazioneIpoteca} from '../pegno/ricevute.jsx';
import {Dettaglio as DettaglioPegno} from '../pegno/dettaglio.jsx';
import {Dettaglio as DettaglioModelloUnico} from '../pegno/dettaglio.jsx';
import {Dettaglio as DettaglioComunicazioniCancellazioneIpoteca} from '../pegno/dettaglio.jsx';
import {DettaglioII as Dettaglio2ModelloUnico} from '../pegno/dettaglioII.jsx';
import {Avvisi as AvvisiModelloUnico} from '../pegno/avvisi.jsx';
import {Home as HomePegno} from '../pegno/home.jsx';
import {Home as HomeMUI} from '../pegno/home.jsx';
import Fermo from '../fermo.jsx';
import Qualifiche from './qualifiche.jsx';
import RichiestaDuplo from '../duplo/richiesta.jsx';
import RicevuteDuplo from '../duplo/ricevuteDuplo.jsx';
import DatiUtente from '../pegno/datiUtente.jsx';
import { inject, observer } from 'mobx-react';
import EsitiContestuali from '../pegno/esitiContestuali.jsx';
import { ProfiloSelezionato } from './profiloSelezionato.jsx';

@inject("rootStore")
@observer
class AppRouter extends React.Component {

   constructor(props) {
     super(props);
     this.qualificheStore = props.rootStore.qualificheStore;
   }

   componentDidMount() {

   }
   componentDidUpdate(prevProps) {
    
      
        console.log(this.props.location.pathname);
        if(
          this.props.location.pathname.includes(ROUTE_FROM_UNIMODWEB_BB)
        ){
          console.log("ho cambiato esitoContestuale")
           this.qualificheStore.setEsitoContestuale(true)
        }
        else{
          this.qualificheStore.setEsitoContestuale(false)
        }
    
  }
   render() {
    
    const isAttivaRichiestaRestituzioneDuplo = process.env.IS_ATTIVA_RICHIESTA_RESTITUZIONE_DUPLO;
    const isAttivaTrasmissionePegno = process.env.IS_ATTIVA_TRASMISSIONE_PEGNO;
    const isAttivaTrasmissioneMUI = process.env.IS_ATTIVA_TRASMISSIONE_MUI;
    const isAttivaTrasmissionePegnoCertificati = process.env.IS_ATTIVA_TRASMISSIONE_PEGNO_CERTIFICATI;
    const isAttivaTrasmissioneCancellazioneIpoteca = process.env.IS_ATTIVA_TRASMISSIONE_CI;
    


    const pickComponent = (Component, condition) => (condition ? Component : NotFound);






     return (
      <>
      
      <ProfiloSelezionato/>
      
      <Switch>
        
          <Route path={process.env.CONTEXT_PATH + ROUTE_PROFILAZIONE} component={Qualifiche} />
          <Route path={process.env.CONTEXT_PATH + ROUTE_ERROR} component={Errore} />       
          <Route path={process.env.CONTEXT_PATH + ROUTE_ASSISTENZA} component={Help} />
          <Route path={process.env.CONTEXT_PATH + ROUTE_ERROR} component={Errore} />
          <Route path={process.env.CONTEXT_PATH + ROUTE_FERMO} component={Fermo} />
          

          {/* Servizio di restituzione del duplo */}

          <Route exact path={process.env.CONTEXT_PATH + ROUTE_FROM_UNIMODWEB + ROUTE_RESTITUZIONE_DUPLO} component={pickComponent(RichiestaDuplo,isAttivaRichiestaRestituzioneDuplo)} /> 
          <Route exact path={process.env.CONTEXT_PATH + ROUTE_FROM_UNIMODWEB + ROUTE_DUPLI_RESTITUITI} component={pickComponent(RicevuteDuplo,isAttivaRichiestaRestituzioneDuplo)} /> 
                    
        {/*Pegno */}
        
          <Route exact path={process.env.CONTEXT_PATH + ROUTE_FROM_PEGNI + ROUTE}>
            <Redirect to={process.env.CONTEXT_PATH + ROUTE_FROM_PEGNI + ROUTE_HOME} />
         </Route> 
          <Route exact path={process.env.CONTEXT_PATH + ROUTE_FROM_PEGNI + ROUTE_HOME_INDEX} component={pickComponent(HomePegno,isAttivaTrasmissionePegno)} /> 
          <Route path={process.env.CONTEXT_PATH + ROUTE_FROM_PEGNI + ROUTE_HOME} component={pickComponent(HomePegno,isAttivaTrasmissionePegno)} /> 
          <Route exact path={process.env.CONTEXT_PATH + ROUTE_FROM_PEGNI + ROUTE_TRASMISSIONE} component={pickComponent(TrasmissionePegno,isAttivaTrasmissionePegno)} /> 
          <Route exact path={process.env.CONTEXT_PATH + ROUTE_FROM_PEGNI + ROUTE_RICEVUTE} component={pickComponent(RicevutePegno,isAttivaTrasmissionePegno)} /> 
          <Route exact path={process.env.CONTEXT_PATH + ROUTE_FROM_PEGNI + ROUTE_RICEVUTE_DETTAGLIO} component={pickComponent(DettaglioPegno,isAttivaTrasmissionePegno)} /> 
         
      
        
       


              {/* Trasmissione Modello unico */}
          
          <Route exact path={process.env.CONTEXT_PATH + ROUTE_FROM_UNIMODWEB + ROUTE_HOME_INDEX} component={pickComponent(HomeMUI,isAttivaTrasmissioneMUI)} /> 
          <Route path={process.env.CONTEXT_PATH + ROUTE_FROM_UNIMODWEB + ROUTE_HOME} component={pickComponent(HomeMUI,isAttivaTrasmissioneMUI)} />
          <Route exact path={process.env.CONTEXT_PATH + ROUTE_FROM_UNIMODWEB + ROUTE_TRASMISSIONE} component={pickComponent(TrasmissioneModelloUnico,isAttivaTrasmissioneMUI)} />
          <Route exact path={process.env.CONTEXT_PATH + ROUTE_FROM_UNIMODWEB + ROUTE_RICEVUTE} component={pickComponent(RicevuteModelloUnico,isAttivaTrasmissioneMUI)} />
          <Route exact path={process.env.CONTEXT_PATH + ROUTE_FROM_UNIMODWEB + ROUTE_RICEVUTE_DETTAGLIO} component={pickComponent(DettaglioModelloUnico,isAttivaTrasmissioneMUI)} />
          <Route exact path={process.env.CONTEXT_PATH + ROUTE_FROM_UNIMODWEB + ROUTE_RICEVUTE_DETTAGLIO_AVVISO} component={pickComponent(AvvisiModelloUnico,isAttivaTrasmissioneMUI)} />
          <Route exact path={process.env.CONTEXT_PATH + ROUTE_FROM_UNIMODWEB + ROUTE_RICEVUTE_DETTAGLIO_2} component={pickComponent(Dettaglio2ModelloUnico,isAttivaTrasmissioneMUI)} />
          <Route exact path={process.env.CONTEXT_PATH + ROUTE_FROM_UNIMODWEB + ROUTE_PAGAMENTO_INTEGRATIVO} component={pickComponent(DatiUtente,isAttivaTrasmissioneMUI)} /> 
           {/* Trasmissione Modello unico - Controlla plico */}
           {/* Trasmissione Modello unico - Controlla plico */}
        <Route exact path={process.env.CONTEXT_PATH + ROUTE_FROM_UNIMODWEB_BB + ROUTE_TRASMISSIONE} component={pickComponent( TrasmissioneModelloUnico, isAttivaTrasmissioneMUI)} />
        <Route exact path={process.env.CONTEXT_PATH + ROUTE_FROM_UNIMODWEB_BB + ROUTE_ESITI_CONTESTUALI} component={pickComponent( EsitiContestuali, isAttivaTrasmissioneMUI)} />
          
           {/*Pegno cERTIFICATI */}
        
           <Route exact path={process.env.CONTEXT_PATH + ROUTE_FROM_PEGNI_CERTIFICATI + ROUTE}>
            <Redirect to={process.env.CONTEXT_PATH + ROUTE_FROM_PEGNI_CERTIFICATI + ROUTE_HOME} />
         </Route> 
          <Route exact path={process.env.CONTEXT_PATH + ROUTE_FROM_PEGNI_CERTIFICATI+ ROUTE_HOME_INDEX} component={pickComponent(HomePegno,isAttivaTrasmissionePegnoCertificati)} /> 
          <Route path={process.env.CONTEXT_PATH + ROUTE_FROM_PEGNI_CERTIFICATI + ROUTE_HOME} component={pickComponent(HomePegno,isAttivaTrasmissionePegnoCertificati)} /> 
          <Route exact path={process.env.CONTEXT_PATH + ROUTE_FROM_PEGNI_CERTIFICATI + ROUTE_TRASMISSIONE} component={pickComponent(TrasmissionePegnoCertificati,isAttivaTrasmissionePegnoCertificati)} /> 
          <Route exact path={process.env.CONTEXT_PATH + ROUTE_FROM_PEGNI_CERTIFICATI + ROUTE_RICEVUTE} component={pickComponent(RicevutePegno,isAttivaTrasmissionePegnoCertificati)} /> 
          <Route exact path={process.env.CONTEXT_PATH + ROUTE_FROM_PEGNI_CERTIFICATI + ROUTE_RICEVUTE_DETTAGLIO} component={pickComponent(DettaglioPegno,isAttivaTrasmissionePegnoCertificati)} /> 
          
          {/*Trasmissione Comunicazioni cancellazioni d'ipoteca 
          @author: fpierantoni 
          @date: 22/01/2024 */}
          <Route exact path={process.env.CONTEXT_PATH + ROUTE_FROM_CANCELLAZIONI_IPOTECA + ROUTE_TRASMISSIONE} component={pickComponent(TrasmissioneComCanc,isAttivaTrasmissioneCancellazioneIpoteca)} />
          
          <Route exact path={process.env.CONTEXT_PATH + ROUTE_FROM_CANCELLAZIONI_IPOTECA + ROUTE_RICEVUTE} component={pickComponent(RicevuteComunicazioniCancellazioneIpoteca,isAttivaTrasmissioneCancellazioneIpoteca)} />
          <Route exact path={process.env.CONTEXT_PATH + ROUTE_FROM_CANCELLAZIONI_IPOTECA + ROUTE_ELENCHI} component={pickComponent((props) => <Elenchi {...props} isElenchi={true} />,isAttivaTrasmissioneCancellazioneIpoteca)} />
          <Route exact path={process.env.CONTEXT_PATH + ROUTE_FROM_CANCELLAZIONI_IPOTECA + ROUTE_RICEVUTE_DETTAGLIO} component={pickComponent(DettaglioComunicazioniCancellazioneIpoteca,isAttivaTrasmissioneCancellazioneIpoteca)} /> 
          
       {/*Link esterni */}
          <Route path={ROUTE_COMPILAZIONE_MUI} render={() => {window.location.href = process.env.LINK_COMPILAZIONE_MUI} }/>  
          <Route path={ROUTE_COMPILAZIONE_CI} render={() => {window.location.href = process.env.LINK_COMPILAZIONE_CI} }/>  
          <Route path={ROUTE_HOME_CI} render={() => {window.location.href = process.env.LINK_HOME_CI} }/>  

          <Route to="*" component={NotFound} />   
     </Switch>
     </>
     )
   }
}

//export  {AppRouter};
// Avvolgi il componente con withRouter prima di esportarlo
export default withRouter(AppRouter);